import { useEffect, useState } from "react";
import RecommendedMovie from "./RecommendedMovie";

export default function Recommendation(props) {
    const [movies, setMovies] = useState([]);

    useEffect(() => {
        const fetchData = async (movieId) => {
            try {
                props.setIsLoading(true);
                setMovies([]);
                const response = await fetch(`https://likethismovie-com.onrender.com/movies/` + movieId);
                
                if (!response.ok) {
                    throw new Error("API isteği başarısız oldu");
                }
                
                const data = await response.json();
                console.log(data);
                setMovies(data || []); 
                props.setIsLoading(false);
            } catch (error) {
                console.error("Film arama hatası:", error);
                setMovies([]);
            }
        };

        const handler = setTimeout(() => {
            fetchData(props.movieId);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [props.movieId]);

    return (
        <div id="recommended-movies" className="mt-4">
            <div className="row">
                {
                    movies.length > 0 ? (
                        movies.map((movie) => 
                            {
                                if(movie.id > 0){
                                  return (<RecommendedMovie 
                                key={movie.id} 
                                title={movie.original_title} 
                                posterPath={movie.poster_path}
                                overview={movie.overview}
                                genres={movie.genres}
                                releaseYear={movie.release_date ? movie.release_date.substring(0, 4) : 'N/A'} 
                            />)
                                }
                            }
                        )
                    ) : (
                        props.movieName && props.movieName.length > 0 && <p>Loading...</p>
                    )
                }
            </div>
        </div>
    );
}